import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';

const biLogger = biLoggerFactory('lp', 19, { msid: 'cea1e625-ef4a-40d7-bef8-2d50ce63a50e' });
const buttons = {
    startNow: "start now",
    createOnWix: "create on Wix",
    createOnEditorX: "Create on Editor X",
    LMEcommerce: "eCommerce learn more",
    learnMore: "learn more",
    LMAcorvid: "Learn More about Corvid",
    LMACollaboration: "Learn More about Collaboration",
    LMADatabases: "Learn More about Databases",
    LMASecurity: "Learn More about Security",
    helloMax: "hellomaxburst.com",
    LMAMAAnalytics: "Learn More about Marketing and Analytics",
    LMAWSEO: "Learn More about Wix SEO",
    LMPProgram: "Learn More Partner Program",
    JPProgram: "Join Partner Program",
    JOCommunity: "Join Our community",
    LMMarketplace: "Learn More Marketplace",
    HAProfessional: "Hire a professional",
    letsTalk: "Let’s Talk",
    LTMarketplace: "Let's Talk",
    LTLastFold: "Let's Talk"
}
const additional_info = {
    letsTalk: 'Partners site HP top fold',
    LTMarketplace: 'Partners site HP marketplace fold',
    LTLastFold: 'Partners site HP bottom fold'
}
const topic = "wix partners site";

$w.onReady(function () {
    pageEvents();
    $w('#repeater1').forEachItem(($item, itemData, index) => {
        if (index > 0) {
            $item('#box150').collapse()
        }
        $item('#vectorImage10').onClick(() => {
            $w('#repeater1').forEachItem(($item1, itemData1, index1) => {
                if (index1 === 3 && (index - 1) % 4 === -1) {
                    $item1('#box150').expand()
                } else if (index1 === (index - 1) % 4) {
                    $item1('#box150').expand()
                }
            })
            $item('#box150').collapse()
        })
        $item('#vectorImage9').onClick(() => {
            $w('#repeater1').forEachItem(($item1, itemData1, index1) => {
                if (index1 === (index + 1) % 4) {
                    $item1('#box150').expand()
                }
            })
            $item('#box150').collapse()
        })
    })
});

function pageEvents() {
    $w("#startCreatingNow").onClick(() => {
        fireEvent(buttons.startNow);
    })
    $w("#startNowWix").onClick(() => {
        fireEvent(buttons.createOnWix);
    })
    $w("#helloMax").onClick(() => {
        fireEvent(buttons.helloMax);
    })
    $w("#startNowEditorx").onClick(() => {
        fireEvent(buttons.createOnEditorX)
    })
    $w("#LMAWSEO").onClick(() => {
        fireEvent(buttons.LMAWSEO)
    })
    $w("#LMMAAnalytics").onClick(() => {
        fireEvent(buttons.LMAMAAnalytics)
    })

    $w("#joinNow").onClick(() => {
        fireEvent(buttons.JPProgram)
    })
    $w("#LMPProgram").onClick(() => {
        fireEvent(buttons.LMPProgram)
    })

    $w("#startCreatingTwo").onClick(() => {
        fireEvent(buttons.startNow)
    })
    $w("#startCreatingThree").onClick(() => {
        fireEvent(buttons.startNow)
    })
    $w("#letsTalkLastFold").onClick(() => {
        fireLetsTalkEvent(buttons.LTLastFold, additional_info.LTLastFold)
    })
    $w("#joinCommunity").onClick(() => {
        fireEvent(buttons.JOCommunity)
    })
    $w("#LMMarketplace").onClick(() => {
        fireEvent(buttons.LMMarketplace)
    })
    $w("#LTMarketplace").onClick(() => {
        fireLetsTalkEvent(buttons.LTMarketplace, additional_info.LTMarketplace)
    })
    $w("#LMMPServices").onClick(() => {
        fireEvent(buttons.LMMarketplace)
    })
    $w("#StartNowHire").onClick(() => {
        fireEvent(buttons.HAProfessional)
    })

    $w("#startNowHeader").onClick(() => {
        fireLetsTalkEvent(buttons.letsTalk, additional_info.letsTalk)
    })

    $w("#LMECommerce").onClick(() => {
        fireEvent(buttons.LMEcommerce)
    })

    $w("#LMAboutCorvid").onClick(() => {
        fireEvent(buttons.LMAcorvid)
    })

    $w("#LMACollaboration").onClick(() => {
        fireEvent(buttons.LMACollaboration)
    })

    $w("#LMdatabase").onClick(() => {
        fireEvent(buttons.LMADatabases)
    })

    $w("#LMASecurity").onClick(() => {
        fireEvent(buttons.LMASecurity)
    })

    $w("#startCreating").onClick(() => {
        fireEvent(buttons.startNow)
    })
}

async function fireEvent(button) {
    //console.log("called")
    try {
        const biEventObject = {
            evid: 703,
            button_name: button,
            is_valid: true,
            topic: topic,
            url: wixLocation.url
        };
        await biLogger.log(biEventObject);
        //console.log("done")
    } catch (error) {
        console.log(error, "sth went wrong")
    }
}

async function fireLetsTalkEvent(button, additional_info) {
    try {
        const biEventObject = {
            evid: 703,
            button_name: button,
            is_valid: true,
            topic: "partners site",
            url: wixLocation.url,
            Additional_info: additional_info
        };
        await biLogger.log(biEventObject);
    } catch (error) {
        console.log(error, "sth went wrong")
    }
}